import React from 'react';
import ModernNode from './ModernNode';
import { NODE_TYPES } from '../../config/nodeConfig';

const PdfNode = (props) => {
  return <ModernNode {...props} nodeType={NODE_TYPES.PDF} />;
};

export default PdfNode;
